import React from 'react'

const ProCourses = () => {
  return (
    <div>
      
    </div>
  )
}

export default ProCourses
